import React from 'react';
import * as css from 'styles'
import { connect } from 'react-redux'

import View from 'components/View/View';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import FadeIn from '../components/Animated/FadeIn';
import Link from '../components/Link/Link';
import List from '../components/List/List';
import Loading from '../components/Loading/Loading';
import Ticker from './Ticker'

import Projects from './Projects';

const Home = ({ content, status }) => {
  const page = (content) ? content[0] : null
  const acf = (page && page.acf) ? page.acf : null

  // return (page) ? (
  return (
    <View padding="0 0 4em 0">
      <FadeIn>

        <Projects />

        <Loading 
          status={status}
          // errormessage="Projects could not be loaded, try refreshing." 
          // height="80vh"
          errormessage=" "
          nospinner
        >
          <Link to="/about">
          <Ticker>
            {acf.ticker_text ? acf.ticker_text : 'GET IT PRODUCTIONS IS A FULL SERVICE PHOTO AND MOTION PRODUCTION COMPANY WITH OFFICES IN NEW YORK AND SAN FRANCISCO '}&nbsp;&nbsp;&nbsp;.&nbsp;.&nbsp;.&nbsp;&nbsp;&nbsp;
          </Ticker>
          </Link>
        </Loading>

      </FadeIn>
    </View>
  ) // : null;
} 

const mapState = state => ({
  content: state.page.data,
  status: state.page.status,
})

export default connect(mapState)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js